import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "cart_v1";

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (item) => {
      setItems((prev) => {
        const ex = prev.find((i) => i.key === item.key);
        if (ex) {
          if (item.isOriginal) return prev;
          return prev.map((i) => (i.key === item.key ? { ...i, quantity: Math.min(10, i.quantity + 1) } : i));
        }
        return [...prev, { ...item, quantity: 1 }];
      });
      setOpen(true);
    };
    const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
    const setQty = (key, q) => setItems((p) => p.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, Math.min(10, q)) } : i)));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    return { items, add, remove, setQty, clear, count, subtotal, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
